module.exports = __webpack_public_path__ + "static/media/4.43eeb284.png";